/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-request.reducer';

export const BloodBankRequestDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankRequestEntity = useAppSelector(state => state.bloodBankRequest.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankRequestDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankRequest.detail.title">BloodBankRequest</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.id}</dd>
          <dt>
            <span id="bloodType">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.bloodType">Blood Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.bloodType}</dd>
          <dt>
            <span id="rhType">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.rhType">Rh Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.rhType}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.productType}</dd>
          <dt>
            <span id="requestedDate">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requestedDate">Requested Date</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.requestedDate}</dd>
          <dt>
            <span id="dispatchedDate">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.dispatchedDate">Dispatched Date</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.dispatchedDate}</dd>
          <dt>
            <span id="unitsRequested">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.unitsRequested">Units Requested</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.unitsRequested}</dd>
          <dt>
            <span id="unitsDispatched">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.unitsDispatched">Units Dispatched</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.unitsDispatched}</dd>
          <dt>
            <span id="reason">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.reason">Reason</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.reason}</dd>
          <dt>
            <span id="requesterId">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requesterId">Requester Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.requesterId}</dd>
          <dt>
            <span id="requesterType">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requesterType">Requester Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.requesterType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.timestampEntry}</dd>
          <dt>
            <span id="transfused">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.transfused">Transfused</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.transfused ? 'true' : 'false'}</dd>
          <dt>
            <span id="ipNumber">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.ipNumber">Ip Number</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.ipNumber}</dd>
          <dt>
            <span id="indications">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.indications">Indications</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.indications}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.uhid}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankRequestEntity.entityId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.bank">Bank</Translate>
          </dt>
          <dd>{bloodBankRequestEntity.bank ? bloodBankRequestEntity.bank.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.forPatient">For Patient</Translate>
          </dt>
          <dd>{bloodBankRequestEntity.forPatient ? bloodBankRequestEntity.forPatient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.status">Status</Translate>
          </dt>
          <dd>{bloodBankRequestEntity.status ? bloodBankRequestEntity.status.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.productComponent">Product Component</Translate>
          </dt>
          <dd>{bloodBankRequestEntity.productComponent ? bloodBankRequestEntity.productComponent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-request" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-request/${bloodBankRequestEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankRequestDetail;
